/**
 * "Explore during onboarding" state for the marketer view (Option 2).
 *
 * When a user who still needs onboarding chooses "Skip for now — explore", we
 * set this flag so MarketerBrandRedirect lets them into the shell instead of
 * the wizard, and MarketerShell shows a persistent "Finish setup" banner to
 * resume. Namespaced per user so it never bleeds across accounts on a shared
 * browser. Transient — cleared when onboarding completes or the user resumes.
 */

const key = (userId: number | string): string =>
  `marketerViewExploring_${userId}`;

export const isExploringOnboarding = (
  userId: number | string | undefined,
): boolean => {
  if (userId === undefined) return false;
  return localStorage.getItem(key(userId)) === 'true';
};

export const setExploringOnboarding = (
  userId: number | string | undefined,
  value: boolean,
): void => {
  if (userId === undefined) return;
  if (value) {
    localStorage.setItem(key(userId), 'true');
  } else {
    localStorage.removeItem(key(userId));
  }
};
